import { AccountObjectFacade } from "../account-object/account-object.facade";
import { Field } from "./field.model";
import { FieldApiFacade } from "./field.api-facade";
import { FieldStoreFacade } from "./field.store-facade";

export class FieldFacade extends AccountObjectFacade<Field, FieldApiFacade, FieldStoreFacade> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/field/field.facade.ts